export default [
  {
    path: '/institutions',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'institutions-list' */ '@/views/institutions/List.vue')
  }, {
    path: '/institutions/new',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'institutions-create' */ '@/views/institutions/Create.vue')
  }, {
    path: '/institutions/:id',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'institutions-page' */ '@/views/institutions/Institution.vue')
  }
]
